import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {ResetPasswordForm} from './Form';
import {ResetPasswordSuccess} from './Success';

const ResetPassword = () => (
  <>
    <Switch>
      <Route path="/reset_password/success" component={ResetPasswordSuccess} />
      <Route path="/reset_password" component={ResetPasswordForm} />
    </Switch>
  </>
);

export {ResetPassword};
